var extrasAdmin = (function ($) {
	var getFormData = function (form) {
		var formObj = {};
		var inputs = $(form).serializeArray();
		$.each(inputs, function (i, input) {
			formObj[input.name] = input.value;
		});
		return formObj;
	};
	return {
		$: $,
		getFormData: getFormData
	};
})(jQuery);
/** @param {extrasAdmin} parent */
extrasAdmin.forms = (function (parent) {
	"use strict";
	var $ = parent.$;
	function init() {
		var $langForms = $('#extras').find('form.lang');
		if ($langForms) {
			$langForms.each(function(){
				setupLang(this);
			});
		}
	}
	function setupLang(form) {
		var $form = $(form);
		addLangBar($form);
		addIndicators($form);
	}
	function addIndicators($form){
		$form.find('div.elm.lang.eType_wysiwyg').each(function(){
			$(this).prepend($('<span/>').addClass('indicator'));
		});
	}
	function addLangBar($form) {
		var langs = getLangs($form);
		var hasTabs = $form.hasClass('ui-tabs');
		var $ul = $('<ul/>').addClass('langPicker ui-widget-header ui-corner-all');
		if (hasTabs) {
			$ul.addClass('usingTabs');
		}
		$.each(langs, function(i, lang) {
			var $li = $('<li/>').addClass('ui-corner-all ' + lang)
				.attr('rel', lang)
				.attr('title', lang);
			$li.append($('<span/>').text(lang));
			$li.click(function(){
				switchLang($form, this);
			});
			$ul.append($li);
		});
		$ul.find('li').first().trigger('click');
		$form.before($ul);
	}
	function switchLang($form, selectedElement) {
		var $langElms = $form.find('div.elm.lang');
		var $selectedElement = $(selectedElement);
		var lang = $selectedElement.attr('rel');
		$langElms.filter('.lang_' + lang).show();
		$langElms.not('.lang_' + lang).hide();
		$selectedElement.parent().find('li').removeClass('selected');
		$selectedElement.addClass('selected');
	}
	function getLangs($form) {
		return $form.data('langs').split(',');
	}

	return {
		init: init
	};
})(extrasAdmin);
document.addEventListener("DOMContentLoaded", function () {
	jQuery(extrasAdmin.forms.init);
});